/* Stylesheet */

.status {
  padding: 0px 16px 0px 16px;
  display: flex;
  height: 21px;
  min-width: 92px;
  border-radius: 21px;
  justify-content: center;
  color: var(--ion-color-text-secondary);
}
